import type { TemplateWrapped } from '@repo/utils';
import { escapeWrapped } from '@repo/utils';

/**
 * FIXME: REOLINK LANG CODE TRANSFORM
 */
const LANG_CODE_FIXME = ['jp', 'en-US'] as const;
const LANG_CODE_FIXME_SET = new Set<string>(LANG_CODE_FIXME);
let LANG_CODE_FIXME_TRANSFORM: Record<(typeof LANG_CODE_FIXME)[number], string> | null = null;

export const getI18nAlternateUrl = ({
    langAreaCodes,
    domain,
    path,
    protocol,
}: {
    langAreaCodes: ReadonlyArray<{ country: string; lang: string; }>;
    domain: string;
    path: string;
    protocol?: string;
}): TemplateWrapped => {
    return escapeWrapped`${langAreaCodes.map(({ lang, country }) => {
        const url = `${protocol ? `${protocol}:` : ''}//${domain}/${country.toLowerCase()}${path}`;
        return escapeWrapped`<link rel="alternate" href="${url}" hreflang="${langCodeTransform(lang)}-${country}" />`;
    })}`;
};

export function langCodeTransform(langCode: string): string {
    if (LANG_CODE_FIXME_SET.has(langCode)) {
        if (!LANG_CODE_FIXME_TRANSFORM) {
            LANG_CODE_FIXME_TRANSFORM = {
                jp: 'ja',
                'en-US': 'en',
            };
        }
        return LANG_CODE_FIXME_TRANSFORM[langCode as (typeof LANG_CODE_FIXME)[number]];
    }
    return langCode;
}
